import AsyncStorage from '@react-native-async-storage/async-storage';
import _ from 'lodash';
import fecha from 'fecha';
import { AUTO_COMPLETE_SEACH_LIMIT } from './RailsConstant';
import { railsConfig, AUTOSUGGEST_URL } from '../RailsConfig';
import fetch2 from '../fetch2';
import { getTomorrow  } from '@mmt/legacy-commons/Helpers/dateHelpers';
import { getRailsLanguageByKey } from '../vernacular/AppLanguage';
import { isOnlyEnglishCharacters } from '../vernacular/VernacularUtils';
import { languageConfig, EN } from '../vernacular/AppLanguage';


const RAILS_RECENT_SEARCHES = 'RAILS_RECENT_SEARCHES';

const _getMatches = (resultText, query) => {
  const index = resultText.toLowerCase().indexOf(query.toLowerCase());
  const textChunks = [];

  if (index !== -1) {
    if (index > 0) {
      textChunks.push({
        text: resultText.substring(0, index),
        matched: false,
      });
    }
    textChunks.push({
      text: resultText.substring(index, index + query.length),
      matched: true,
    });
    if (index + query.length < resultText.length) {
      textChunks.push({
        text: resultText.substring(index + query.length, resultText.length + 1),
        matched: false,
      });
    }
  } else {
    textChunks.push({
      text: resultText,
      matched: false,
    });
  }

  return {
    matches: textChunks,
  };
};

const _getConcatString = (string1, string2) => {
  let concatinatedString = '';
  if (!_.isEmpty(string1) && !_.isEmpty(string2)) {
    concatinatedString = `${string1}, ${string2}`;
  } else if (_.isEmpty(string1) && _.isEmpty(string2)) {
    concatinatedString = '';
  } else if (_.isEmpty(string1)) {
    concatinatedString = string2;
  } else if (_.isEmpty(string2)) {
    concatinatedString = string1;
  }
  return concatinatedString;
};
const getAutoCompleteCities = async (text, selectedLanguage = getRailsLanguageByKey("beCode"), signal = null, isLiveStation = false ) => {
  if (text === '' || text == null) {
    return [];
  }

  try {
    const language = isOnlyEnglishCharacters(text) ? "en" : "hi";
    const apiResponse = await fetch2(AUTOSUGGEST_URL
      .replace("__query__", encodeURI(text.toLowerCase()))
      .replace("__limit__", AUTO_COMPLETE_SEACH_LIMIT)
      .replace("__language__", isLiveStation ? languageConfig[EN].id : language)
      .replace("__langcode__", isLiveStation ? languageConfig[EN].id : selectedLanguage), {
        method: 'GET',
        signal
      });
    const result = await apiResponse.json();
    if (!result.success) {
      throw new Error('API Failed');
    }
    return _.reduce(
      result.data.r,
      (acc, station) => {
        const res = {
          id: station._id.toString(),
          code: station.irctc_code,
          stationName: station.dn,
          cityName: _.isEmpty(station.xtr.cn) || _.isNull(station.xtr.cn) ? station.dn : station.xtr.cn,
          stateName:
            _.isEmpty(station.xtr.st_n) || _.isNull(station.xtr.st_n) ? '' : station.xtr.st_n,
          language: selectedLanguage,
          codeMatches: _getMatches(station.irctc_code, text),
          stationNameMatches: _getMatches(station.dn, text),
          cityStateNameMatches: _getMatches(
            _getConcatString(station.xtr.cn, station.xtr.st_n),
            text,
          ),
        };
        const group = _.map(station.xtr.grp_irctc, (station) => ({
          id: station._id.toString(),
          code: station.irctc_code,
          stationName: station.dn,
          cityName: _.isEmpty(station.xtr.cn) || _.isNull(station.xtr.cn) ? station.dn : station.xtr.cn,
          stateName:
            _.isEmpty(station.xtr.st_n) || _.isNull(station.xtr.st_n) ? '' : station.xtr.st_n,
          language: selectedLanguage,
          engTranslate:
            selectedLanguage === 'en' || _.isEmpty(station.mt) || _.isNull(station.mt)
              ? ''
              : station.mt,
          codeMatches: _getMatches(station.irctc_code, text),
          stationNameMatches: _getMatches(station.dn, text),
          cityStateNameMatches: _getMatches(
            _getConcatString(station.xtr.cn, station.xtr.st_n),
            text,
          ),
        }));
        return [...acc, res, ...group];
      },
      [],
    );
  } catch (e) {
    if (e?.name === 'AbortError') throw new Error(e.name);
    throw new Error('getAutoCompleteCities API Failed');
  }
};

export const addToRecentSearches = async (searchData) => {
  let recentSearches = await getRecentSearches();
  const { from, to, departureDate } = searchData;
  const id = `${from.code}_${to.code}_${departureDate}`;
  recentSearches = _.filter(recentSearches, (e) => id !== e.id);
  recentSearches = _.take(recentSearches, 4);
  recentSearches = [
    {
      id,
      ...searchData,
    },
    ...recentSearches,
  ];
  await AsyncStorage.setItem(RAILS_RECENT_SEARCHES, JSON.stringify(recentSearches));
  return recentSearches;
};

export const getRecentCities = async () => {
  let recentSearches = await getRecentSearches();
  recentSearches = _.take(recentSearches, 2);
  return _.uniqBy(
    _.flatMap(recentSearches, (searchData) => [searchData.from, searchData.to]),
    'code',
  );
};

export const getRecentSearches = async () => {
  try {
    const result = await AsyncStorage.getItem(RAILS_RECENT_SEARCHES);
    if (!result) {
      return [];
    }
    const rsJSON = JSON.parse(result);
    return validateDataInRecentSearches(rsJSON);
  } catch (e) {
    return [];
  }
};

const validateDataInRecentSearches = (rsJSON) => {
  const currentLang = getRailsLanguageByKey("cookieCode");
  let recentSearchesBasedOnLanguage = _.filter(rsJSON, (json) => json.language === currentLang);
  let result = [];
  _.forEach(recentSearchesBasedOnLanguage, (json) => {
    let { from, to, departureDate } = json;
    if (_.isEmpty(departureDate)) {
      departureDate = fecha.format(getTomorrow(), 'DD-MM-YYYY');
      const searchData = {
        from,
        to,
        departureDate,
      };
      const id = `${from.code}_${to.code}_${departureDate}`;
      result = [...result, { id, ...searchData }];
    } else {
      result = [...result, { ...json }];
    }
  });
  return result;
};

export const getMMTExclusiveSectionData = async () => {
  try {
    const response = await fetch2(railsConfig.getExclusiveSectionData);
    const result = await response.json();
    if (response.status !== 200) {
      console.log('getMMTExclusiveSectionData api failed');
      return null;
    }
    return result;
  } catch (e) {
    console.log('getMMTExclusiveSectionData API Failed', e);
    return null;
  }
};

export const getStationDetails = async (station, language) => {
  if (_.isEmpty(station)) {
    return station;
  }

  let stationArr = [];
  try {
    stationArr = await getAutoCompleteCities(
      station.code,
      getRailsLanguageByKey("cookieCode"),
    );
  } catch (error) {
    return station;
  }


  let resultStation = stationArr.find((x) => x.code.toLowerCase() === station.code.toLowerCase());
  if (resultStation) {
    return {
      ...station,
      ...{
        stationName: resultStation.stationName,
        cityName: resultStation.cityName,
        stateName: resultStation.stateName,
        language: resultStation.language,
      },
    };
  } else {
    return station;
  }
};

export const showInvalidQueryInHindiError = (userQuery) => {
  return getRailsLanguageByKey("cookieCode") === "eng" && !isOnlyEnglishCharacters(userQuery);
};

export const areOriginDestinationDetailsPresent = (railsLanding) => (
  !_.isEmpty(railsLanding) && !_.isEmpty(railsLanding?.destinationStation) && !_.isEmpty(railsLanding?.originStation)
)

export default getAutoCompleteCities;
